module.exports = __webpack_public_path__ + "img/600f.54a7ad0e.png";